// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file plugnmeet_insights.proto (package plugnmeet, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file plugnmeet_insights.proto.
 */
export const file_plugnmeet_insights: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message plugnmeet.InsightsSupportedLangInfo
 */
export type InsightsSupportedLangInfo = Message<"plugnmeet.InsightsSupportedLangInfo"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string locale = 3;
   */
  locale: string;
};

/**
 * Describes the message plugnmeet.InsightsSupportedLangInfo.
 * Use `create(InsightsSupportedLangInfoSchema)` to create a new message.
 */
export const InsightsSupportedLangInfoSchema: GenMessage<InsightsSupportedLangInfo> = /*@__PURE__*/
  messageDesc(file_plugnmeet_insights, 0);

/**
 * @generated from message plugnmeet.InsightsTranscriptionConfigReq
 */
export type InsightsTranscriptionConfigReq = Message<"plugnmeet.InsightsTranscriptionConfigReq"> & {
  /**
   * @generated from field: bool is_enabled = 1;
   */
  isEnabled: boolean;

  /**
   * @generated from field: repeated string allowed_spoken_langs = 2;
   */
  allowedSpokenLangs: string[];

  /**
   * @generated from field: repeated string allowed_speech_users = 3;
   */
  allowedSpeechUsers: string[];

  /**
   * @generated from field: bool is_enabled_translation = 4;
   */
  isEnabledTranslation: boolean;

  /**
   * @generated from field: repeated string allowed_trans_langs = 5;
   */
  allowedTransLangs: string[];

  /**
   * @generated from field: optional string default_subtitle_lang = 6;
   */
  defaultSubtitleLang?: string | undefined;

  /**
   * @generated from field: bool is_enabled_speech_synthesis = 7;
   */
  isEnabledSpeechSynthesis: boolean;
};

/**
 * Describes the message plugnmeet.InsightsTranscriptionConfigReq.
 * Use `create(InsightsTranscriptionConfigReqSchema)` to create a new message.
 */
export const InsightsTranscriptionConfigReqSchema: GenMessage<InsightsTranscriptionConfigReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_insights, 1);

/**
 * @generated from message plugnmeet.InsightsTranscriptionUserSessionReq
 */
export type InsightsTranscriptionUserSessionReq = Message<"plugnmeet.InsightsTranscriptionUserSessionReq"> & {
  /**
   * @generated from field: plugnmeet.InsightsUserSessionAction action = 1;
   */
  action: InsightsUserSessionAction;

  /**
   * @generated from field: optional string spoken_lang = 2;
   */
  spokenLang?: string | undefined;

  /**
   * @generated from field: bool allowed_transcription_storage = 3;
   */
  allowedTranscriptionStorage: boolean;
};

/**
 * Describes the message plugnmeet.InsightsTranscriptionUserSessionReq.
 * Use `create(InsightsTranscriptionUserSessionReqSchema)` to create a new message.
 */
export const InsightsTranscriptionUserSessionReqSchema: GenMessage<InsightsTranscriptionUserSessionReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_insights, 2);

/**
 * @generated from message plugnmeet.InsightsTranscriptionResult
 */
export type InsightsTranscriptionResult = Message<"plugnmeet.InsightsTranscriptionResult"> & {
  /**
   * @generated from field: string from_user_id = 1;
   */
  fromUserId: string;

  /**
   * @generated from field: string from_user_name = 2;
   */
  fromUserName: string;

  /**
   * @generated from field: string lang = 3;
   */
  lang: string;

  /**
   * @generated from field: string text = 4;
   */
  text: string;

  /**
   * @generated from field: bool is_partial = 5;
   */
  isPartial: boolean;

  /**
   * @generated from field: bool allowed_transcription_storage = 6;
   */
  allowedTranscriptionStorage: boolean;

  /**
   * A map of target language -> translated text
   *
   * @generated from field: map<string, string> translations = 7;
   */
  translations: { [key: string]: string };
};

/**
 * Describes the message plugnmeet.InsightsTranscriptionResult.
 * Use `create(InsightsTranscriptionResultSchema)` to create a new message.
 */
export const InsightsTranscriptionResultSchema: GenMessage<InsightsTranscriptionResult> = /*@__PURE__*/
  messageDesc(file_plugnmeet_insights, 3);

/**
 * @generated from message plugnmeet.InsightsChatTranslationConfigReq
 */
export type InsightsChatTranslationConfigReq = Message<"plugnmeet.InsightsChatTranslationConfigReq"> & {
  /**
   * @generated from field: bool is_enabled = 1;
   */
  isEnabled: boolean;

  /**
   * @generated from field: repeated string allowed_trans_langs = 5;
   */
  allowedTransLangs: string[];

  /**
   * @generated from field: optional string default_lang = 6;
   */
  defaultLang?: string | undefined;
};

/**
 * Describes the message plugnmeet.InsightsChatTranslationConfigReq.
 * Use `create(InsightsChatTranslationConfigReqSchema)` to create a new message.
 */
export const InsightsChatTranslationConfigReqSchema: GenMessage<InsightsChatTranslationConfigReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_insights, 4);

/**
 * @generated from message plugnmeet.InsightsTranslateTextReq
 */
export type InsightsTranslateTextReq = Message<"plugnmeet.InsightsTranslateTextReq"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;

  /**
   * @generated from field: string source_lang = 2;
   */
  sourceLang: string;

  /**
   * @generated from field: repeated string target_langs = 3;
   */
  targetLangs: string[];
};

/**
 * Describes the message plugnmeet.InsightsTranslateTextReq.
 * Use `create(InsightsTranslateTextReqSchema)` to create a new message.
 */
export const InsightsTranslateTextReqSchema: GenMessage<InsightsTranslateTextReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_insights, 5);

/**
 * @generated from message plugnmeet.InsightsTextTranslationResult
 */
export type InsightsTextTranslationResult = Message<"plugnmeet.InsightsTextTranslationResult"> & {
  /**
   * @generated from field: string source_text = 1;
   */
  sourceText: string;

  /**
   * @generated from field: string source_lang = 2;
   */
  sourceLang: string;

  /**
   * map of lang_code -> translated_text
   *
   * @generated from field: map<string, string> translations = 3;
   */
  translations: { [key: string]: string };
};

/**
 * Describes the message plugnmeet.InsightsTextTranslationResult.
 * Use `create(InsightsTextTranslationResultSchema)` to create a new message.
 */
export const InsightsTextTranslationResultSchema: GenMessage<InsightsTextTranslationResult> = /*@__PURE__*/
  messageDesc(file_plugnmeet_insights, 6);

/**
 * @generated from message plugnmeet.InsightsTranslateTextRes
 */
export type InsightsTranslateTextRes = Message<"plugnmeet.InsightsTranslateTextRes"> & {
  /**
   * @generated from field: bool status = 1;
   */
  status: boolean;

  /**
   * @generated from field: string msg = 2;
   */
  msg: string;

  /**
   * @generated from field: optional plugnmeet.InsightsTextTranslationResult result = 3;
   */
  result?: InsightsTextTranslationResult | undefined;
};

/**
 * Describes the message plugnmeet.InsightsTranslateTextRes.
 * Use `create(InsightsTranslateTextResSchema)` to create a new message.
 */
export const InsightsTranslateTextResSchema: GenMessage<InsightsTranslateTextRes> = /*@__PURE__*/
  messageDesc(file_plugnmeet_insights, 7);

/**
 * @generated from message plugnmeet.InsightsGetSupportedLanguagesReq
 */
export type InsightsGetSupportedLanguagesReq = Message<"plugnmeet.InsightsGetSupportedLanguagesReq"> & {
  /**
   * @generated from field: plugnmeet.InsightsServiceType service_type = 1;
   */
  serviceType: InsightsServiceType;
};

/**
 * Describes the message plugnmeet.InsightsGetSupportedLanguagesReq.
 * Use `create(InsightsGetSupportedLanguagesReqSchema)` to create a new message.
 */
export const InsightsGetSupportedLanguagesReqSchema: GenMessage<InsightsGetSupportedLanguagesReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_insights, 8);

/**
 * @generated from message plugnmeet.InsightsGetSupportedLanguagesRes
 */
export type InsightsGetSupportedLanguagesRes = Message<"plugnmeet.InsightsGetSupportedLanguagesRes"> & {
  /**
   * @generated from field: bool status = 1;
   */
  status: boolean;

  /**
   * @generated from field: string msg = 2;
   */
  msg: string;

  /**
   * @generated from field: repeated plugnmeet.InsightsSupportedLangInfo languages = 3;
   */
  languages: InsightsSupportedLangInfo[];
};

/**
 * Describes the message plugnmeet.InsightsGetSupportedLanguagesRes.
 * Use `create(InsightsGetSupportedLanguagesResSchema)` to create a new message.
 */
export const InsightsGetSupportedLanguagesResSchema: GenMessage<InsightsGetSupportedLanguagesRes> = /*@__PURE__*/
  messageDesc(file_plugnmeet_insights, 9);

/**
 * @generated from message plugnmeet.InsightsGetUserStatusRes
 */
export type InsightsGetUserStatusRes = Message<"plugnmeet.InsightsGetUserStatusRes"> & {
  /**
   * @generated from field: bool status = 1;
   */
  status: boolean;

  /**
   * @generated from field: string msg = 2;
   */
  msg: string;

  /**
   * @generated from field: plugnmeet.InsightsServiceType service_type = 3;
   */
  serviceType: InsightsServiceType;

  /**
   * @generated from field: bool is_active = 4;
   */
  isActive: boolean;

  /**
   * @generated from field: optional string spoken_lang = 5;
   */
  spokenLang?: string | undefined;

  /**
   * @generated from field: optional bool allowed_transcription_storage = 6;
   */
  allowedTranscriptionStorage?: boolean | undefined;
};

/**
 * Describes the message plugnmeet.InsightsGetUserStatusRes.
 * Use `create(InsightsGetUserStatusResSchema)` to create a new message.
 */
export const InsightsGetUserStatusResSchema: GenMessage<InsightsGetUserStatusRes> = /*@__PURE__*/
  messageDesc(file_plugnmeet_insights, 10);

/**
 * @generated from message plugnmeet.InsightsAITextChatContent
 */
export type InsightsAITextChatContent = Message<"plugnmeet.InsightsAITextChatContent"> & {
  /**
   * @generated from field: plugnmeet.InsightsAITextChatRole role = 1;
   */
  role: InsightsAITextChatRole;

  /**
   * @generated from field: string text = 2;
   */
  text: string;

  /**
   * @generated from field: optional string stream_id = 3;
   */
  streamId?: string | undefined;
};

/**
 * Describes the message plugnmeet.InsightsAITextChatContent.
 * Use `create(InsightsAITextChatContentSchema)` to create a new message.
 */
export const InsightsAITextChatContentSchema: GenMessage<InsightsAITextChatContent> = /*@__PURE__*/
  messageDesc(file_plugnmeet_insights, 11);

/**
 * @generated from message plugnmeet.InsightsAITextChatStreamResult
 */
export type InsightsAITextChatStreamResult = Message<"plugnmeet.InsightsAITextChatStreamResult"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string text = 2;
   */
  text: string;

  /**
   * @generated from field: bool is_last_chunk = 3;
   */
  isLastChunk: boolean;

  /**
   * @generated from field: uint32 prompt_tokens = 4;
   */
  promptTokens: number;

  /**
   * @generated from field: uint32 completion_tokens = 5;
   */
  completionTokens: number;

  /**
   * @generated from field: uint32 total_tokens = 6;
   */
  totalTokens: number;

  /**
   * @generated from field: string createdAt = 7;
   */
  createdAt: string;
};

/**
 * Describes the message plugnmeet.InsightsAITextChatStreamResult.
 * Use `create(InsightsAITextChatStreamResultSchema)` to create a new message.
 */
export const InsightsAITextChatStreamResultSchema: GenMessage<InsightsAITextChatStreamResult> = /*@__PURE__*/
  messageDesc(file_plugnmeet_insights, 12);

/**
 * @generated from message plugnmeet.InsightsAITextChatConfigReq
 */
export type InsightsAITextChatConfigReq = Message<"plugnmeet.InsightsAITextChatConfigReq"> & {
  /**
   * @generated from field: bool is_enabled = 1;
   */
  isEnabled: boolean;

  /**
   * @generated from field: bool is_allowed_everyone = 3;
   */
  isAllowedEveryone: boolean;

  /**
   * @generated from field: repeated string allowed_user_ids = 4;
   */
  allowedUserIds: string[];
};

/**
 * Describes the message plugnmeet.InsightsAITextChatConfigReq.
 * Use `create(InsightsAITextChatConfigReqSchema)` to create a new message.
 */
export const InsightsAITextChatConfigReqSchema: GenMessage<InsightsAITextChatConfigReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_insights, 13);

/**
 * @generated from message plugnmeet.InsightsAIMeetingSummarizationConfigReq
 */
export type InsightsAIMeetingSummarizationConfigReq = Message<"plugnmeet.InsightsAIMeetingSummarizationConfigReq"> & {
  /**
   * @generated from field: bool is_enabled = 1;
   */
  isEnabled: boolean;

  /**
   * @generated from field: string summarization_prompt = 3;
   */
  summarizationPrompt: string;
};

/**
 * Describes the message plugnmeet.InsightsAIMeetingSummarizationConfigReq.
 * Use `create(InsightsAIMeetingSummarizationConfigReqSchema)` to create a new message.
 */
export const InsightsAIMeetingSummarizationConfigReqSchema: GenMessage<InsightsAIMeetingSummarizationConfigReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_insights, 14);

/**
 * @generated from enum plugnmeet.InsightsServiceType
 */
export enum InsightsServiceType {
  /**
   * @generated from enum value: INSIGHTS_SERVICE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INSIGHTS_SERVICE_TYPE_TRANSCRIPTION = 1;
   */
  TRANSCRIPTION = 1,

  /**
   * @generated from enum value: INSIGHTS_SERVICE_TYPE_TRANSLATION = 2;
   */
  TRANSLATION = 2,

  /**
   * @generated from enum value: INSIGHTS_SERVICE_TYPE_SPEECH_SYNTHESIS = 3;
   */
  SPEECH_SYNTHESIS = 3,

  /**
   * @generated from enum value: INSIGHTS_SERVICE_TYPE_AI_TEXT_CHAT = 4;
   */
  AI_TEXT_CHAT = 4,

  /**
   * @generated from enum value: INSIGHTS_SERVICE_TYPE_CHAT_TRANSLATION = 5;
   */
  CHAT_TRANSLATION = 5,

  /**
   * @generated from enum value: INSIGHTS_SERVICE_TYPE_MEETING_SUMMARIZING = 6;
   */
  MEETING_SUMMARIZING = 6,
}

/**
 * Describes the enum plugnmeet.InsightsServiceType.
 */
export const InsightsServiceTypeSchema: GenEnum<InsightsServiceType> = /*@__PURE__*/
  enumDesc(file_plugnmeet_insights, 0);

/**
 * @generated from enum plugnmeet.InsightsUserSessionAction
 */
export enum InsightsUserSessionAction {
  /**
   * @generated from enum value: USER_SESSION_ACTION_UNSPECIFIED = 0;
   */
  USER_SESSION_ACTION_UNSPECIFIED = 0,

  /**
   * @generated from enum value: USER_SESSION_ACTION_START = 1;
   */
  USER_SESSION_ACTION_START = 1,

  /**
   * @generated from enum value: USER_SESSION_ACTION_STOP = 2;
   */
  USER_SESSION_ACTION_STOP = 2,
}

/**
 * Describes the enum plugnmeet.InsightsUserSessionAction.
 */
export const InsightsUserSessionActionSchema: GenEnum<InsightsUserSessionAction> = /*@__PURE__*/
  enumDesc(file_plugnmeet_insights, 1);

/**
 * start AI Text Chat
 *
 * @generated from enum plugnmeet.InsightsAITextChatRole
 */
export enum InsightsAITextChatRole {
  /**
   * @generated from enum value: INSIGHTS_AI_TEXT_CHAT_ROLE_UNSPECIFIED = 0;
   */
  INSIGHTS_AI_TEXT_CHAT_ROLE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: INSIGHTS_AI_TEXT_CHAT_ROLE_SYSTEM = 1;
   */
  INSIGHTS_AI_TEXT_CHAT_ROLE_SYSTEM = 1,

  /**
   * @generated from enum value: INSIGHTS_AI_TEXT_CHAT_ROLE_USER = 2;
   */
  INSIGHTS_AI_TEXT_CHAT_ROLE_USER = 2,

  /**
   * @generated from enum value: INSIGHTS_AI_TEXT_CHAT_ROLE_MODEL = 3;
   */
  INSIGHTS_AI_TEXT_CHAT_ROLE_MODEL = 3,
}

/**
 * Describes the enum plugnmeet.InsightsAITextChatRole.
 */
export const InsightsAITextChatRoleSchema: GenEnum<InsightsAITextChatRole> = /*@__PURE__*/
  enumDesc(file_plugnmeet_insights, 2);

